<template>
  <div class="g-bd">
    <div class="con-tag news-tag">
      <h2>新 <span>/</span>闻 <span>/</span>资 <span>/</span>讯</h2>
    </div>
    <div class="con-body news-body">
      <newsList></newsList>
    </div>
  </div>
</template>

<script>
import newsList from "./newsList.vue";
export default {
  components: {
    newsList,
  },
  name: "news",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
</style>
